import { Component, OnInit, HostListener } from '@angular/core';
import { Router, NavigationEnd,NavigationStart } from '@angular/router';
import { UserService } from '../app/services';
import { DanhMucService } from './services';
import { environment } from './../environments/environment';
import {googleAnalyticsHeadScripts, googleAnalytics} from '../assets/ga/script';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>  <router-outlet name="print"></router-outlet>',
  providers: [DanhMucService]
})
export class AppComponent implements OnInit {
  constructor(private router: Router, private user: UserService) {
    if (sessionStorage.getItem(environment.TimeOut) == undefined) {
      localStorage.removeItem(environment.LOCAL_USER_NAME);
      sessionStorage.clear();
    }
    if (this.user.checkLoggedIn() == false) {
      this.router.navigate(['/pages/login']);
    }
    this.router.events.filter(event => event instanceof NavigationStart).subscribe(event => {
      const url = event['url'];
      if (url !== null && url !== undefined && url !== '' && url.indexOf('null') < 0) {
        googleAnalytics(url);
      }
    });
  }

  ngOnInit() {

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;

      }
      window.scrollTo(0, 0)
    });
  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/app.component.ts